import React, { useState, useEffect } from "react";
import axios from "axios";
import NavbarAdmin from "../NavbarAdmin/NavbarAdmin";
import FooterIndex from "../../components/footerHomePage/footerHomePage";
//import moment from "moment";
//import Swal from "sweetalert2";

const ListUserProv = () => {
  //const [cuit, setCuit] = useState("");
  //const [typeProvider, setTypeProvider] = useState("");
  const [sales, setSales] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_GET_ALL_SUPPLIER);
      setSales(response.data);
    } catch (error) {}
  };

  /*const handleFilterClick = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_SALES_ALL_SUPPLIER,
        {
          params: {
            fromDate: fromDate,
            toDate: toDate,
            cuit: cuit,
            typeProvider: typeProvider,
          },
        }
      );

      setSales(response.data);
    } catch (error) {}
  };*/

  /*const handleFilterClickdate = async () => {
    try {
      const fromDateMoment = moment(fromDate, "YYYY-MM-DD");
      const toDateMoment = moment(toDate, "YYYY-MM-DD");

      // Calcular la diferencia en meses
      const differenceInMonths = toDateMoment.diff(fromDateMoment, "months");

      if (differenceInMonths > 3) {
        // La diferencia entre las fechas es mayor a 3 meses
        Swal.fire({
          icon: "warning",
          title: "Algo salió mal.",
          text: "La diferencia entre las fechas no puede ser mayor a 3 meses.",
        });
      } else {
        const response = await axios.get(
          process.env.REACT_APP_SALES_ALL_SUPPLIER,
          {
            params: {
              fromDate: fromDate,
              toDate: toDate,
              cuit: cuit,
              typeProvider: typeProvider,
            },
          }
        );

        setSales(response.data);
      }
    } catch (error) {}
  };*/

  return (
    <div className="backgounrdprov">
      <NavbarAdmin />
      <div className="allboxlistprovadmin">
        {/*<div className="allsearch">
          <div className="boxdisplaysearch" style={{ width: "100%" }}>
            <div className="inputboxadmin">
              <input
                style={{ width: "99%" }}
                className="inputsearchadmin"
                type="text"
                placeholder="Buscar Comercializador"
                value={typeProvider}
                onChange={(e) => setTypeProvider(e.target.value)}
              />
            </div>
            <div className="inputboxadmin">
              <div className="inputboxadmin">
                <input
                  style={{ width: "99%" }}
                  className="inputsearchadmin"
                  type="text"
                  placeholder="Buscar CUIT"
                  value={cuit}
                  onChange={(e) => setCuit(e.target.value)}
                />
              </div>
            </div>
            <div>
              <button
                className="buttonfilteradmin"
                onClick={handleFilterClickdate}
              >
                Filtrar
              </button>
            </div>
          </div>
  </div>*/}

        <div className="alllistprov">
          <div className="headerlistprovadmin">
            <p
              id="listprov"
              className="infoprovlistletter leftlistprev firtsborder"
            >
              Nombre del Comercializador
            </p>
            <p id="listprov" className="infoprovlistletter bottonlistprev">
              Cuit
            </p>
            <p id="listprov" className="infoprovlistletter bottonlistprev">
              Estado
            </p>
            <p
              id="listprov"
              className="infoprovlistletter bottonlistprev lastborder"
            >
              Tipo
            </p>
          </div>
          {sales.map((sale, index) => (
            <div className="headerlistprovadmin marginlistprov" key={index}>
              <p id="listprov" className="infoprovlistletter leftlistprev2">
                {sale.nameAndLastName}
              </p>
              <p id="listprov" className="infoprovlistletter leftlistprev2">
                {sale.cuit}
              </p>
              <p id="listprov" className="infoprovlistletter bottonlistprev2">
                {sale.status}
              </p>
              <p id="listprov" className="infoprovlistletter bottonlistprev2">
                {sale.type}
              </p>
            </div>
          ))}
        </div>
      </div>
      <FooterIndex />
    </div>
  );
};

export default ListUserProv;
